<template>
  <header id="header" class="bg-white position-sticky top-0" style="z-index: 1050;" :style="'height: ' + headerContentHeight + 'px;'">
    <div class="border-bottom header-content" ref="headerContent">
      <!-- Top bar -->
      <div class="bg-black text-white">
        <div class="container oversized-container py-2">
          <div class="d-flex align-items-center justify-content-between small">
            <div class="d-flex align-items-center">
              <span class="mr-3 d-flex align-items-center">
                <i class="fa-solid fa-phone mr-2"></i>
                <span class="font-weight-bold">1-800-DEC-PARTS</span>
              </span>
              <span class="d-none d-md-inline">Mon-Fri 8AM-6PM EST</span>
            </div>
            <!-- <div class="d-flex align-items-center">
              <button type="button" class="btn btn-link text-white p-0 mr-3 text-decoration-none small">Track Order</button>
              <button type="button" class="btn btn-link text-white p-0 text-decoration-none small">Sign In</button>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Main header -->
      <div class="container oversized-container py-lg-2">
        <b-navbar toggleable="lg" type="light" variant="light" class="navbar-menu">
          <b-navbar-brand to="/">
            <img
              src="public/images/logo.png"
              alt="DEC"
              class="header-logo cursor-pointer"
            >
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse">
            <i class="fa-sharp fa-solid fa-bars"></i>
          </b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <li class="nav-item nav-item-categories position-relative">
                <button
                  type="button"
                  class="nav-link categories-trigger d-flex align-items-center"
                  :class="{ active: showCategoriesMenu }"
                  @click="toggleCategoriesMenu"
                >
                  <span>Products</span>
                  <i class="fa-solid fa-chevron-down ml-2 small categories-chevron" :class="{ 'is-open': showCategoriesMenu }"></i>
                </button>

                <div
                  v-if="showCategoriesMenu"
                  class="fake-bg"
                  @click="closeCategoriesMenu"
                ></div>

                <div
                  v-if="showCategoriesMenu"
                  class="categories-panel d-none d-lg-block"
                >
                  <div class="categories-panel-header">
                    <span class="categories-panel-title">Browse by Category</span>
                    <button type="button" class="btn btn-link btn-sm text-muted p-0" @click="closeCategoriesMenu">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <router-link
                    to="/products?k=&c=&b=&s=name&page=1"
                    class="categories-all-link"
                    @click.native="closeCategoriesMenu"
                  >
                    <i class="fa-solid fa-border-all mr-2"></i>
                    All Products
                  </router-link>

                  <div class="categories-grid" v-if="categoryOptions.length">
                    <button
                      type="button"
                      v-for="(category, cInx) in categoryOptions"
                      :key="'cInx-'+cInx"
                      class="categories-item"
                      @click="goToCategory(category.id)"
                    >
                      <i class="fa-solid fa-gears categories-item-icon"></i>
                      <span>{{ category.name }}</span>
                    </button>
                  </div>

                  <p class="categories-empty small text-muted mb-0" v-else>
                    No categories available.
                  </p>
                </div>

                <div
                  v-if="showCategoriesMenu"
                  class="categories-mobile-list d-lg-none"
                >
                  <router-link
                    to="/products?k=&c=&b=&s=name&page=1"
                    class="categories-mobile-link"
                    @click.native="closeCategoriesMenu"
                  >
                    All Products
                  </router-link>
                  <button
                    type="button"
                    v-for="(category, cInx) in categoryOptions"
                    :key="'cmInx-'+cInx"
                    class="categories-mobile-link"
                    @click="goToCategory(category.id)"
                  >
                    {{ category.name }}
                  </button>
                </div>
              </li>

              <b-nav-item to="/guarantee">Guarantee</b-nav-item>
              <b-nav-item to="/about-us">About Us</b-nav-item>
              <b-nav-item class="d-lg-none" to="/contact"><i class="fa-solid fa-envelope fa-lg"></i> Contact</b-nav-item>
              <b-nav-item class="ml-lg-3 special-nav-item" to="/sale?k=&c=&b=&s=name&page=1">Sale</b-nav-item>
            </b-navbar-nav>

            <!-- <b-navbar-nav class="ml-lg-2 ml-xl-4 mt-3 mt-lg-0 d-none d-lg-inline-block">
              <b-form-select class="w-auto brand-filter" size="sm" v-model="selectedBrand">
                <b-form-select-option value="">Filter by brand</b-form-select-option>
                <b-form-select-option :value="b.id" v-for="(b, bInx) in brandOptions" :key="'bInx-'+bInx">{{ b.name }}</b-form-select-option>
              </b-form-select>
            </b-navbar-nav> -->

            <b-navbar-nav class="mt-2 mt-lg-0 ml-lg-1 ml-xl-4 d-none d-lg-inline-block navbar-nav-autocomplete">
              <!-- Autocomplete dropdown -->
              <b-form class="position-relative flex-grow-1 box-autocomplete" @submit="onSubmit">
                <input
                  type="search"
                  class="form-control pr-5"
                  placeholder="Search parts..."
                  minlength="3"
                  v-model="searchQuery"
                >
                <button
                  type="submit"
                  class="btn btn-warning btn-sm position-absolute"
                  style="right: 4px; top: 50%; transform: translateY(-50%);"
                >
                  <i class="fa-solid fa-magnifying-glass txt-csecondary"></i>
                </button>

                <div class="fake-bg" v-if="showSuggestions && filteredSuggestions.length > 0" @click="closeAutocomplete"></div>
                <div
                  v-if="showSuggestions && filteredSuggestions.length > 0"
                  class="position-absolute w-100 border rounded shadow-sm bg-white overflow-hidden box-autocomplete"
                  style="top: 100%; left: 0; margin-top: 8px; z-index: 50;"
                  @click="closeAutocomplete"
                >
                  <router-link :to="'/product/'+$root._converToURL(suggestion.name, suggestion.id)"
                    v-for="(suggestion, fsInx) in filteredSuggestions"
                    :key="'fsInx-'+fsInx"
                    type="submit"
                    class="btn btn-link btn-block text-left text-dark text-decoration-none d-flex align-items-center py-3"
                  >
                    <!-- <i class="fa-solid fa-magnifying-glass text-muted mr-2"></i> -->
                    <div class="d-flex align-items-center box-image">
                      <img class="img-fluid placed-backg" src="public/images/pages/products/product.png" :style="{ backgroundImage: 'url('+ (suggestion.image ? suggestion.image : 'public/images/pages/products/placeholder.svg') +')' }">
                    </div>
                    <div class="d-flex flex-column box-text">
                      <span class="d-block small text-muted sku">{{ suggestion.sku }}</span>
                      <span class="d-block f-w-700 name">{{ suggestion.name }}</span>
                      <div class="text-price" v-if="$root.logged && suggestion.distributor">
                        <span class="price" v-if="!suggestion.price_offer">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(suggestion.distributor_unit_price) }}</span>
                        <span class="price text-danger" v-else>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(suggestion.price_offer) }}</span>
                        <!-- <span class="price text-muted line-through" v-if="suggestion.price_offer">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(suggestion.price) }}</span> -->
                        <span class="usd" :class="{ 'text-danger': suggestion.price_offer }">USD</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </b-form>
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto">
              <div class="d-flex align-items-center mt-2 mt-lg-0 box-icons">
                <h6 class="text-right f-w-600 d-none d-lg-inline-block" v-if="$root.logged">Hola {{ userName($root.user.company) }}</h6>
                <!-- <button type="button" class="btn btn-link text-dark p-2 d-md-none">
                  <i class="fa-solid fa-magnifying-glass fa-lg"></i>
                </button> -->
                <router-link to="/contact" class="btn btn-link text-dark p-2">
                  <i class="fa-solid fa-envelope fa-lg"></i>
                </router-link>
                <router-link class="btn btn-link text-dark p-2" to="/login">
                  <i class="fa-solid fa-user fa-lg"></i>
                </router-link>
                <!-- <router-link to="/cart" class="btn btn-link text-dark p-2 position-relative">
                  <i class="fa-solid fa-cart-shopping fa-lg"></i>
                  <span class="position-absolute badge badge-danger badge-pill" style="top: 2px; right: 2px; min-width: 20px; height: 20px; font-size: 11px; display: flex; align-items: center; justify-content: center; padding: 0;">
                    0
                  </span>
                </router-link> -->
                <!-- <button type="button" class="btn btn-link text-dark p-2 d-md-none">
                  <i class="fa-solid fa-bars fa-lg"></i>
                </button> -->
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <!-- Mobile search -->
        <div class="d-lg-none px-3 pb-2">
          <b-form class="position-relative w-100" @submit="onSubmit">
            <input
              type="search"
              class="form-control pr-5"
              placeholder="Search parts..."
              minlength="3"
              v-model="searchQuery"
            >
            <button
              type="submit"
              class="btn btn-warning btn-sm position-absolute"
              style="right: 4px; top: 50%; transform: translateY(-50%);"
            >
              <i class="fa-solid fa-magnifying-glass txt-csecondary"></i>
            </button>
          </b-form>
        </div>
      </div>
      <!--  -->
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      headerContentHeight: 0,
      filteredSuggestions: [],

      searchQuery: '',
      showSuggestions: true,
      showCategoriesMenu: false,
      selectedBrand: '',
      blurTimeout: null,
      brandOptions: [
        // { id: 'all', name: 'All Brands' },
      ],
      categoryOptions: [],
    };
  },

  methods: {
    updateHeaderContentHeight() {      
      this.headerContentHeight = this.$refs.headerContent ? this.$refs.headerContent.offsetHeight : 0;
    },
    
    onSubmit(event) {
      event.preventDefault();
      this.$router.push({ path: '/search', query: { k: this.searchQuery, c: '', b: this.selectedBrand, s: 'name', page: 1 } });
    },

    getBrandsOptions() {
      axios.get(tools.url('/api/brands-options')).then((response) => {
        this.brandOptions = response.data;
      });
    },

    getCategoriesOptions() {
      axios.get(tools.url('/api/categories-options')).then((response) => {
        this.categoryOptions = response.data;
      });
    },

    toggleCategoriesMenu() {
      this.closeAutocomplete();
      this.showCategoriesMenu = !this.showCategoriesMenu;
      this.$nextTick(() => {
        this.updateHeaderContentHeight();
      });
    },

    closeCategoriesMenu() {
      this.showCategoriesMenu = false;
      this.$nextTick(() => {
        this.updateHeaderContentHeight();
      });
    },

    goToCategory(categoryId) {
      this.closeCategoriesMenu();
      this.$router.push({
        path: '/products',
        query: { k: '', c: categoryId, b: '', s: 'name', page: 1 },
      });
    },

    closeAutocomplete() {
      this.showSuggestions = false;
      this.filteredSuggestions = [];
    },

    userName(name) {
      if (!name) {
        return '';
      }

      let result = name.slice(0, 16);

      if (name.length > 16) {
        result += "...";
      }

      return result;
    }
  },

  beforeMount() {
    this.getBrandsOptions();
    this.getCategoriesOptions();
  },

  mounted() {
    // Inicializa el alto de la div cuando el componente se monta
    this.updateHeaderContentHeight();

    // Añadir un listener para el cambio de tamaño de la ventana
    window.addEventListener('resize', this.updateHeaderContentHeight);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeaderContentHeight);

    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
    }
  },

  watch: {
    searchQuery(newVal) {
      if (newVal.length >= 3) {
        axios.post(tools.url('/api/products/autocomplete'), { keywords: newVal }).then((response) => {
          this.filteredSuggestions = response.data;
          this.showSuggestions = true;
        });
      } else {
        this.showSuggestions = false;
        this.filteredSuggestions = [];
      }
    },

    "$route": function(v) {
      this.closeAutocomplete();
      this.closeCategoriesMenu();
    },
  }
};
</script>
